import FullscreenIcon from '@mui/icons-material/Fullscreen';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
// import ScrollTrigger from 'react-scroll-trigger';
import { useInView } from 'react-intersection-observer';

import ExciseSubMenu from '@/components/nav/ExciseSubMenu';
import Hidden from '@/components/ui/TzoHidden';
// import Popup1099NEC from '@/components/ui/1099PopupNec';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const FormW8BEN = () => {
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Now Accepting <span style="color:#1da94a; font-weight: 600;">Form 1098-E</span> for Tax Year 2024!`,
  //   SubHeading: 'File your student loan interest deductions with ease.  ',
  //   CtaText: ' Get Started Today!',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form1098e`,
  //   isActive: true,
  // };

  // const [visible, setVisible] = useState(false);

  // const onEnterViewport = () => {
  //   setVisible(true);
  // };

  // const onExitViewport = () => {
  //   setVisible(false);
  // };

  const videoRef = useRef<HTMLVideoElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpenSemiFullscreen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [visible, setVisible] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false, // change to true if you only want to animate once
  });

  useEffect(() => {
    setVisible(inView);
  }, [inView]);

  // const { ref, inView } = useInView({
  //   threshold: 0.2,
  //   triggerOnce: true,
  // });
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Form 2290 Click2File | Get Instant IRS Schedule 1"
          description="E-file Form 2290 online with TaxZerone Click2File. Auto-fill truck details, prevent errors, and download your IRS-stamped Schedule 1 instantly after filing."
          keywords=""
          canonical="excise-tax/click2file-form-2290/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg=""
        />
      }
    >
      <ExciseSubMenu />

      {/* <ComingSoonPopup open={open} setOpen={setOpen} /> */}
      <Box
        sx={{ mt: 0, py: { xs: 1, sm: 5 }, minHeight: { lg: 285 } }}
        className="click2file-img-bg"
      >
        <Container
          sx={{
            position: 'relative',
            pt: 0,
            mb: 0,
            // maxWidth: { xs: '100%', sm: 820, md: 820, lg: 940 },
          }}
          maxWidth="lg"
        >
          <Box
            sx={{
              background: '#d95623',
              p: 1,
              px: 2,
              color: '#fff',
              '&.ribbon:before': {
                left: { xs: 8, sm: 16 },
                background:
                  'url(/assets/images/ribbon-bg-new.webp) repeat 100%',
                transform: 'rotate(-360deg)',
              },
              '&.ribbon:after': {
                right: { xs: 8, sm: 16 },
                background:
                  'url(/assets/images/ribbon-bg-new.webp) repeat 100%',
                transform: 'rotate(-180deg)',
              },
            }}
            className="ribbon"
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems="center"
              spacing={{ xs: 1, sm: 2 }}
              justifyContent="center"
            >
              <Typography
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 16, sm: 18, md: 18, lg: '1.13rem' },
                  color: '#eee',
                }}
              >
                <strong>Attention Truckers! </strong> E-File{' '}
                <b style={{ color: '#fff', fontWeight: 600 }}>Form 2290 Now </b>
                to Stay Compliant for the
                <b style={{ color: '#fff' }}> 2 026–27 Tax Year</b>
              </Typography>
              {/* <Box>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: 'center',
                    mb: { xs: 1, sm: 1 },
                    lineHeight: 1.3,
                    color: '#ececec',
                  }}
                >
                  Time left to file before the deadline{' '}
                  <Hidden smUp>
                    <br />
                  </Hidden>
                  (
                  <span style={{ fontWeight: 600, color: '#fff' }}>
                    Sept 02, 2025
                  </span>
                  ):
                </Typography> */}
              {/* <Countdown date={lastDayTaxSeason} renderer={renderer} /> */}
              {/* </Box> */}
              <Box sx={{ textAlign: 'right' }}>
                <Button
                  variant="contained"
                  size="large"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=click2file2290`}
                  sx={{
                    backgroundColor: '#fff',
                    '&:hover, &:focus': {
                      backgroundColor: '#333',
                      color: '#fff',
                      boxShadow: 'none',
                    },
                    px: 2,
                    color: '#333',
                    mt: { xs: 0, md: 0 },
                    display: { xs: 'inline-block', sm: 'inline-block' },
                    mx: { xs: 'auto', sm: 1 },
                    borderRadius: 3,
                    boxShadow: 'none',
                    fontSize: 18,
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                  }}
                >
                  E-File Now
                </Button>
              </Box>
            </Stack>
          </Box>
        </Container>
        <Container maxWidth="xl" sx={{}}>
          <Box
            component="header"
            sx={{
              mt: { xs: 2, sm: 4, md: 10 },
              mb: { xs: 2, sm: 4, md: 5 },
              position: 'relative',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#fff',
                mb: 2,
              }}
            >
              E-File IRS Form 2290 Online with{' '}
              <span style={{ color: '#ffe400', fontWeight: 700 }}>
                Click2File
              </span>{' '}
              <img
                src="/assets/images/click2file-icon.webp"
                loading="lazy"
                alt="IRS-authorized e-file provider"
                className="mw-100"
                width={60}
                height={59}
                style={{ marginBottom: '-12.5px' }}
              />
              <br />
              <Box
                component="p"
                sx={{
                  fontSize: { lg: 30, md: 24, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#ffcf7cff',
                  mb: 3,
                  mt: 0,
                }}
              >
                America&apos;s #1 Trusted Form 2290 E-Filing Platform for
                Truckers
              </Box>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                lineHeight: 1.5,
                mb: 3,
                color: '#d0d0d0',
              }}
            >
              Click2File pre-fills your Form 2290 with last year’s data.
              IRS-approved, secure, and fast. <br />
              Get <b style={{ color: '#fff' }}>Schedule 1 </b> in minutes!
            </Typography>

            <Stack
              direction={{ xs: 'column-reverse', md: 'row' }}
              spacing={{ xs: 1, md: 6 }}
              justifyContent={{
                xs: 'center',
                md: 'center',
              }}
              alignItems="center"
              sx={{ mt: 3 }}
            >
              <Box
                sx={{
                  textAlign: { xs: 'center', md: 'center' },
                  mr: { xs: 0, md: 4 },
                }}
              >
                <Button
                  variant="contained"
                  className="btn-secondary medium"
                  sx={{
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus,&:active': {
                      backgroundColor: '#1a7738 !important',
                      transform: 'scale(1.1)',
                    },
                  }}
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=click2file-form-2290`}
                >
                  E-file Form 2290
                </Button>
              </Box>
              <Stack
                direction="row"
                spacing={2}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
              >
                <Box
                  sx={{
                    mb: { xs: '0 !important', md: '0px !important' },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/irs-authorized.webp" />
                    <source srcSet="/assets/images/irs-authorized.png" />
                    <Box
                      component="img"
                      src="/assets/images/irs-authorized.png"
                      loading="lazy"
                      alt="IRS-authorized e-file provider"
                      width={70}
                      height={69}
                      sx={{
                        width: { xs: 50, md: 70 },
                        height: { xs: 49, md: 69 },
                      }}
                    />
                  </picture>
                </Box>
                <Box
                  sx={{
                    mb: { xs: '0px !important', md: '0px !important' },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/tzo-soc2.webp" />
                    <source srcSet="/assets/images/tzo-soc2.png" />
                    <Box
                      component="img"
                      src="/assets/images/tzo-soc2.png"
                      loading="lazy"
                      alt="TZO SOC2 Compliant"
                      width={90}
                      height={89}
                      sx={{
                        width: { xs: 70, md: 90 },
                        height: { xs: 69, md: 89 },
                      }}
                    />
                  </picture>
                </Box>
              </Stack>
            </Stack>
          </Box>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Trusted by America&apos;s Trucking Community
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 2,
                  fontSize: { md: 18, sm: 16, xs: 15 },
                  textAlign: 'center',
                }}
              >
                Join thousands of satisfied truckers who file their Form 2290
                with confidence.{' '}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} m={2}>
            <Grid size={{ xs: 10, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  background:
                    'linear-gradient(135deg, #336ca2ff, #4490afff, #4e89b3ff)',
                  color: '#fff',
                  borderRadius: 3,
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <strong>
                      <CountUp
                        end={50000}
                        duration={2}
                        suffix="+"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    </strong>
                  ) : (
                    'Forms Filed '
                  )}
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#fff',
                  }}
                >
                  Forms Filed
                </strong>
              </Paper>
            </Grid>
            <Grid size={{ xs: 10, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  background:
                    'linear-gradient(135deg, #336ca2ff, #4490afff, #4e89b3ff)',
                  borderRadius: 3,
                  color: '#fff',
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <strong>
                      <CountUp
                        end={99}
                        duration={10} // no animation
                        decimals={0} // no decimal
                        suffix="%"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    </strong>
                  ) : (
                    'IRS Acceptance  '
                  )}
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#fff',
                  }}
                >
                  IRS Acceptance
                </strong>
              </Paper>
            </Grid>
            <Grid size={{ xs: 10, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  background:
                    'linear-gradient(135deg, #336ca2ff, #4490afff, #4e89b3ff)',
                  borderRadius: 3,
                  color: '#fff',
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <strong>
                      <CountUp
                        end={3}
                        duration={2}
                        suffix="Min"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    </strong>
                  ) : (
                    'Average Filing Time  '
                  )}
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#fff',
                  }}
                >
                  Average Filing Time
                </strong>
              </Paper>
            </Grid>
            <Grid size={{ xs: 10, sm: 6, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  p: 2,
                  background:
                    'linear-gradient(135deg, #336ca2ff, #4490afff, #4e89b3ff)',
                  borderRadius: 3,
                  color: '#fff',
                  width: '100%',
                  height: 'auto',
                  minHeight: '100%',
                  border: 'none',
                  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                }}
              >
                <Box component="div" ref={ref}>
                  {visible ? (
                    <strong>
                      <CountUp
                        end={30000}
                        duration={2}
                        suffix="+"
                        style={{
                          fontWeight: 600,
                          fontSize: 44,
                        }}
                      />
                    </strong>
                  ) : (
                    'Trucking Business  '
                  )}
                </Box>
                <strong
                  style={{
                    fontSize: 18,
                    fontWeight: 600,
                    marginTop: 1,
                    color: '#fff',
                  }}
                >
                  Trucking Business
                </strong>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={{ md: 6, xs: 12 }} textAlign="left">
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/what-is-click2file.webp" />
                  <source srcSet="/assets/images/what-is-click2file.png" />
                  <img
                    src="/assets/images/what-is-click2file.png"
                    alt="what-is-click2file?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={450}
                    height={450}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is Click2File?
                  <img
                    src="/assets/images/click2file-icon.webp"
                    loading="lazy"
                    alt="IRS-authorized e-file provider"
                    className="mw-100"
                    width={60}
                    height={59}
                    style={{ marginBottom: '-13.5px', marginLeft: '12.5px' }}
                  />
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Click2File is a feature offered by TaxZerone that makes tax
                  filing easier for returning users. It automatically transfers
                  key details from your previous year’s return into your current
                  year’s filing, so you don’t have to start from scratch. This
                  not only saves time but also helps reduce the risk of errors,
                  giving you a faster, smoother, and more accurate tax
                  preparation experience.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to E-File IRS Form 2290 Using Click2File
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Follow the easy steps to send Authorization of Reporting Agent
              </Typography> */}
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: !open ? 'flex' : 'none', // Hide when dialog is open
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                position: 'relative',
                left: { xl: '-2%' },
                '& video': { width: { xs: '100%', xl: 'auto' } },
              }}
            >
              <video
                ref={videoRef}
                src="/assets/videos/2290-click2file.mp4"
                autoPlay
                loop
                muted
                playsInline
                className="mw-100"
              >
                click2file
              </video>

              {/* Semi-fullscreen trigger button */}
              <Tooltip title="Expand" arrow>
                <IconButton
                  onClick={handleOpenSemiFullscreen}
                  sx={{
                    position: 'absolute',
                    bottom: 16,
                    right: 16,
                    bgcolor: 'rgba(0,0,0,0.6)',
                    color: 'white',
                    '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' },
                  }}
                >
                  <FullscreenIcon />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Semi-Fullscreen Dialog */}
            <Dialog
              open={open}
              onClose={handleClose}
              maxWidth="lg"
              fullWidth
              PaperProps={{
                sx: {
                  bgcolor: 'black',
                  borderRadius: 2,
                },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  p: 2,
                }}
              >
                <video
                  ref={videoRef}
                  src="/assets/videos/2290-click2file.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls
                  style={{
                    width: '100%',
                    height: '80vh',
                    borderRadius: '12px',
                  }}
                />
              </Box>
            </Dialog>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt=" Invite the Recipient"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Log in & Select Click2File
                    </Typography>
                    <Typography variant="body1">
                      Access your TaxZerone account and choose Click2File to
                      automatically pre-fill your previous return’s information.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Recipient Fills & Signs"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review & Update Details
                    </Typography>
                    <Typography variant="body1">
                      Check the pre-filled vehicle and business information.
                      Update VIN, taxable gross weight, or first used month
                      (FUM) if needed.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Download & Save"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Submit & Get Schedule 1
                    </Typography>
                    <Typography variant="body1">
                      Transmit your return securely to the IRS and receive your
                      stamped Schedule 1 instantly- ready for your records or
                      DMV proof.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Box sx={{ mt: 3, textAlign: 'left' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=click2file-form-2290`}
                >
                  File 2290 Now
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why 50,000+ Truckers Choose TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Truckers nationwide trust TaxZerone for simple, secure, and
                IRS-authorized{' '}
                <Link
                  href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                  sx={{ color: '#0202ff' }}
                >
                  {' '}
                  2290 e-filing
                </Link>{' '}
                every year.
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="IRS Approved & Secure"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Approved & Secure
                </Typography>
                <Typography variant="body1">
                  As an{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    IRS-authorized e-file provider{' '}
                  </span>
                  , TaxZerone guarantees secure, accurate, and compliant Form
                  2290 filings with instant IRS acceptance.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fast-filing-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fast-filing-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fast-filing-icon.png"
                      alt=" Lightning-Fast E-Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Lightning-Fast E-Filing
                </Typography>
                <Typography variant="body1">
                  Complete your Form 2290 in{' '}
                  <span style={{ fontWeight: 600 }}> under 3 minutes </span>{' '}
                  with our pre-populated data system. No more tedious manual
                  entry!{' '}
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/accurate-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/accurate-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/accurate-icon.png"
                      alt="100% Accurate"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  100% Accurate
                </Typography>
                <Typography variant="body1">
                  Our system ensures{' '}
                  <span style={{ fontWeight: 600 }}> error-free filing </span>{' '}
                  by automatically transferring verified data from your previous
                  returns.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Instant Schedule 1"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Schedule 1
                </Typography>
                <Typography variant="body1">
                  Get your stamped Schedule 1 copy immediately after filing.{' '}
                  <span style={{ fontWeight: 600 }}> No waiting for mail </span>{' '}
                  - print and go! Perfect for DOT inspections, with the option
                  to deliver it directly to your carrier company.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/affordable-pricing-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/affordable-pricing-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/affordable-pricing-icon.png"
                      alt="Affordable Pricing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  Competitive pricing with{' '}
                  <span style={{ fontWeight: 600 }}> no hidden fees </span>. Pay
                  only for what you need - single vehicle or fleet options.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Trucker Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Trucker Support
                </Typography>
                <Typography variant="body1">
                  Our friendly support team is always ready to give you a quick
                  response and guide you through every step of
                  e-filing—available via{' '}
                  <span style={{ fontWeight: 600 }}> live chat, email, </span>{' '}
                  and <span style={{ fontWeight: 600 }}> phone. </span>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          background: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
          {/* Header */}
          <Box textAlign="center" mb={6}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 700,
                lineHeight: 1.3,
                mb: 1,
              }}
            >
              How Click2File Works?
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Revolutionary technology that saves you time and eliminates errors
            </Typography>
          </Box>
          <Box
            textAlign="center"
            mb={8}
            sx={{
              background: 'linear-gradient(145deg, #fef9f9, #f3f4f6)',
              borderRadius: 8,
              py: 6,
              px: { xs: 2, md: 6 },
              boxShadow:
                'inset 4px 4px 12px #cacacaff, inset -4px -4px 12px #cacacaff',
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 28, md: 26, sm: 24, xs: 22 },
                fontWeight: 700,
                lineHeight: 1.3,
                mb: 2,
                background: 'linear-gradient(90deg, #464646ff, #646464ff)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Pre-Populate Your Current Return with Click2File!
            </Typography>
            <Typography
              variant="body1"
              sx={{ mt: 1, maxWidth: 700, mx: 'auto', color: '#232323ff' }}
            >
              Click2File takes the hassle out of tax preparation by
              automatically transferring relevant data from your previous return
              to your current one.
            </Typography>

            {/* Steps */}
            <Grid
              container
              spacing={4}
              justifyContent="center"
              alignItems="stretch"
              mt={4}
            >
              {/* Returning Users */}
              <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    borderRadius: 6,
                    background: '#fff',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
                    transition: '0.35s ease',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      transform: 'translateY(-8px) scale(1.02)',
                      boxShadow: '0 12px 28px rgba(100, 209, 153, 0.69)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 80,
                      height: 80,
                      borderRadius: '50%',
                      mb: 3,
                      background: 'linear-gradient(135deg, #388e3c, #66bb6a)',
                      color: 'white',
                      mx: 'auto',
                      // boxShadow: '0 6px 12px rgba(56,142,60,0.4)',
                    }}
                  >
                    <img
                      src="/assets/images/returning-users-icon.png"
                      alt="Returning Users"
                      loading="lazy"
                      width={49}
                      height={49}
                    />
                  </Box>
                  <Typography
                    variant="h3"
                    fontWeight={700}
                    gutterBottom
                    sx={{ fontSize: '18px !important' }}
                  >
                    Returning Users
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: '#676767ff',
                      mb: 1,
                    }}
                  >
                    Access Click2File Feature
                  </Typography>
                  <Typography variant="body2">
                    Previous TaxZerone users can instantly access Click2File to
                    auto-fill their returns using last year’s information.
                  </Typography>
                </Paper>
              </Grid>

              {/* New Users */}
              <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    borderRadius: 6,
                    background: '#fff',
                    boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
                    transition: '0.35s ease',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    '&:hover': {
                      transform: 'translateY(-8px) scale(1.02)',
                      boxShadow: '0 12px 28px rgba(132, 185, 255, 0.69)',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 80,
                      height: 80,
                      borderRadius: '50%',
                      mb: 3,
                      background:
                        'linear-gradient(135deg, #2f84d3ff, #509defff)',
                      color: 'white',
                      mx: 'auto',
                      // boxShadow: '0 6px 12px rgba(211,47,47,0.4)',
                    }}
                  >
                    <img
                      src="/assets/images/new-users-icon.png"
                      alt="  New Users"
                      loading="lazy"
                      width={49}
                      height={49}
                    />
                  </Box>
                  <Typography
                    variant="h3"
                    fontWeight={700}
                    gutterBottom
                    sx={{ fontSize: '18px !important' }}
                  >
                    New Users
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: 14,
                      color: '#676767ff',
                      mb: 1,
                    }}
                  >
                    Automagic2290, Manual or Bulk Filing
                  </Typography>
                  <Typography variant="body2">
                    New users can file using{' '}
                    <Link
                      href="/resources/excise-tax/automagic2290/"
                      sx={{ color: '#2020ff' }}
                    >
                      Automagic2290
                    </Link>
                    , manually, or via bulk filing options. Once you file with
                    us, you&apos;ll have <b>Click2File access</b> for all future
                    returns!
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Button
              variant="contained"
              sx={{
                mt: 0,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=click2file-form-2290`}
            >
              E-file Form 2290
            </Button>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ my: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              textAlign="center"
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Comparison Table: Click2File vs. Other Filing Methods
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  mb: 3,
                }}
              >
                <Link
                  href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                  sx={{ color: '#0202ff' }}
                >
                  Filing Form 2290
                </Link>{' '}
                with{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  Click2File at TaxZerone{' '}
                </span>{' '}
                gives truckers unmatched{' '}
                <span style={{ fontWeight: 600 }}>
                  {' '}
                  speed, accuracy, and instant IRS Schedule 1 access.{' '}
                </span>{' '}
                Unlike paper filing or other e-file providers, Click2File
                ensures a smooth and reliable Heavy Vehicle Use Tax (HVUT)
                filing experience.
              </Typography>
              <Box
                component="div"
                sx={{
                  mb: 2,

                  textAlign: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                  display: 'flex',
                }}
              >
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 2 }}
                >
                  <Table aria-label="Features Comparison Table">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 250,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Features
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 250,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Click2File (TaxZerone)
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 250,
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Paper Filing
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 250,
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            fontSize: 16,
                          }}
                        >
                          Other E-file Providers
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Speed
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          File in minutes and get your{' '}
                          <b>IRS Schedule 1 instantly</b>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Weeks of mailing and manual processing
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Hours to days depending on provider
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Errors
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <b>Built-in VIN validation</b> & automatic tax checks
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          High risk of errors due to manual review
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Limited or no error-checks
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Schedule 1 Delivery
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <b>Instant IRS-stamped Schedule 1</b> via
                          email/download and also, TaxZerone delivers Schedule 1
                          directly to the carrier company.
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Delivered by mail after long delays
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          May take hours or require extra steps
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Support
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <b> Live chat, email,</b> and <b>phone</b>
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          No real-time assistance
                        </TableCell>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          Often limited or slow response
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          IRS Approved
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          <b>Yes</b> – fully IRS-authorized e-file provider
                        </TableCell>
                        <TableCell
                          sx={{
                            borderRight: '1px solid #828282',
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          No
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'center',
                            backgroundColor: '#fff',
                            fontSize: 16,
                          }}
                        >
                          While IRS-approved, some providers may not be
                          consistently reliable.
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          background: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                What Truckers Are Saying About Click2File
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  mb: { xs: 1, sm: 3 },
                }}
              >
                Truckers trust Click2File for fast, error-free Form 2290 filing
                and instant IRS Schedule 1.
              </Typography>

              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
                sx={{ mb: 3 }}
              >
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        I used taxzerone Click2File to file my Form 2290, and it
                        was super easy. It filled in my truck details
                        automatically and saved me a lot of time.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right', mt: 4 }}
                    >
                      - David Moreno
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        Best filing experience I’ve ever had. Click2File made my
                        Form 2290 accurate & quick with instant Schedule 1
                        proof.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right', mt: 4 }}
                    >
                      -Nicole Snyder
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#fff',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        The support team at TaxZerone was excellent. They guided
                        me through Click2File and helped me file my 2290
                        quickly.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      -Michael Monroe
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to file your Form 2290 instantly?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Get your IRS-approved Schedule 1 instantly with fast and error-free
          HVUT filing using Click2File.
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=click2file-form-2290`}
          >
            E-File 2290 Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is Form 2290 Click2File?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 1 }}>
                      Form 2290 Click2File is a TaxZerone feature that
                      simplifies filing the{' '}
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        IRS Form 2290
                      </Link>{' '}
                      for the Heavy Vehicle Use Tax (HVUT). It lets returning
                      users pre-fill current year tax info by automatically
                      importing vehicle details, EIN, and taxable gross weight
                      from prior filings. This speeds up filing, reduces errors,
                      and provides an instant stamped Schedule 1.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Can I edit pre-filled data in Click2File?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      <b>Yes!</b> Click2File lets you review and edit all
                      pre-filled information before submitting your{' '}
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        2290 Form
                      </Link>
                      . You can update vehicle details, EIN, taxable gross
                      weight, and first used month (FUM) to ensure everything is
                      accurate. Once confirmed, submit securely and receive your{' '}
                      <Link
                        href="/resources/excise-tax/form-2290-schedule-1/"
                        sx={{ color: '#0202ff' }}
                      >
                        IRS-stamped Schedule 1
                      </Link>{' '}
                      instantly.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who can use Click2File?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 0 }}>
                      Click2File is available only for returning TaxZerone
                      users. New users must{' '}
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        e-file Form 2290
                      </Link>{' '}
                      manually or use bulk upload for multiple vehicles. Once a
                      new user completes a TaxZerone submission, Click2File
                      becomes available for future filings.
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. How much does Click2File cost for Form 2290?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1, mb: 0 }}>
                      Click2File is <b>FREE for returning TaxZerone users</b>{' '}
                      who{' '}
                      <Link
                        href="/excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
                        sx={{ color: '#2020ff' }}
                      >
                        file Form 2290 online
                      </Link>
                      . There’s no extra charge for pre-populating your current
                      return with last year’s data. You only pay the standard
                      IRS Form 2290 e-file fee and any applicable vehicle tax.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-2290/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FormW8BEN;
